//区分是添加单品还是修改单品
export default ({
    state: {
        status: {}
    },
    mutations: {
        setNow(state, status) {
            state.status = status
        }
    },
    actions: {
        setSing(context, status) {
            context.commit('setNow', status)
        }
    }
})